import { createSlice } from '@reduxjs/toolkit';

// Initialize with some default practice areas
const initialState = {
  areas: [
    { id: 'corporate', name: 'Corporate Law', iconName: 'Briefcase', count: 42 },
    { id: 'litigation', name: 'Litigation', iconName: 'Gavel', count: 38 },
    { id: 'ip', name: 'Intellectual Property', iconName: 'FileText', count: 27 },
    { id: 'tax', name: 'Tax Law', iconName: 'DollarSign', count: 19 },
    { id: 'banking', name: 'Banking & Finance', iconName: 'DollarSign', count: 24 },
    { id: 'employment', name: 'Employment Law', iconName: 'Users', count: 31 },
    { id: 'dataprivacy', name: 'Data Privacy', iconName: 'Shield', count: 15 },
    { id: 'compliance', name: 'Regulatory Compliance', iconName: 'Scale', count: 22 },
  ],
  currentAreaId: null,
};

const PracticeAreaSlice = createSlice({
  name: 'practiceAreas',
  initialState,
  reducers: {
    setCurrentArea: (state, action) => {
      state.currentAreaId = action.payload;
    },
    addPracticeArea: (state, action) => {
      state.areas.push(action.payload);
    },
    updatePracticeAreaCount: (state, action) => {
      const { areaId, count } = action.payload;
      const area = state.areas.find(a => a.id === areaId);
      if (area) {
        area.count = count;
      }
    },
  },
});


export const { 
  setCurrentArea, 
  addPracticeArea, 
  updatePracticeAreaCount 
} = PracticeAreaSlice.actions;

export default PracticeAreaSlice.reducer;